import { tenantQueries } from './tenant';
import { catalogQueries } from './catalog';
import { requestQueries } from './request';
import { productQueries } from './product';
// Export all admin queries
export const adminQueries = {
  tenant: tenantQueries,
  request: requestQueries,
  catalog: catalogQueries,
  product: productQueries,
}; 